import { useState, useRef, useEffect } from "react";
import computerImg from "./assets/images/screen-off.png";
import clickSound from "./assets/sounds/click-sound-2.wav";
import MainScreen from "./components/main-screen";
import powerOn from "./assets/images/power-on.png";
import powerOff from "./assets/images/power-off.png";
import bgImage from "./assets/images/desktop-bg.png";
import {
  FaLinkedin,
  FaGithub,
  FaCode,
  FaEnvelope,
  FaPowerOff,
} from "react-icons/fa";
import { SiLeetcode, SiCodechef, SiCodeforces } from "react-icons/si";

function App() {
  const [isPowerOn, setIsPowerOn] = useState(false);
  const [initalPower, setInitalPower] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const audioRef = useRef(new Audio(clickSound));
  const mainScreenRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  setTimeout(() => {
    if (!isPowerOn) {
      setInitalPower(true);
    }
  }, 1000);

  const handlePowerButton = () => {
    setIsPowerOn((prev) => !prev);

    if (!isPowerOn) {
      setIsPowerOn(true);
      setTimeout(() => {
        if (mainScreenRef.current) {
          mainScreenRef.current.style.display = "block";
        }
      }, 500);
    } else {
      setIsPowerOn(false);
      if (mainScreenRef.current) {
        mainScreenRef.current.style.display = "none";
      }
    }
    if (isPowerOn) {
      setTimeout(() => {
        audioRef.current.play();
      }, 250);
    } else {
      audioRef.current.play();
    }
  };

  const socialLinks = [
    { href: "https://linkedin.com/in/dhruvatri001", Icon: FaLinkedin },
    { href: "mailto:dhruvatri001@gmail.com", Icon: FaEnvelope },
    { href: "https://github.com/dhruvatri", Icon: FaGithub },
    { href: "https://codolio.com/profile/dhruvatri", Icon: FaCode },
    { href: "https://leetcode.com/coderack", Icon: SiLeetcode },
    { href: "https://www.codechef.com/users/dhruvatri", Icon: SiCodechef },
    { href: "https://codeforces.com/profile/dhruvatri001", Icon: SiCodeforces },
  ];

  return (
    <div className="relative h-screen w-full overflow-hidden bg-black">
      {!isMobile && (
        <div
          className={`relative w-full h-full transition-transform duration-500 ease-in-out ${
            isPowerOn ? "scale-200" : "scale-100"
          }`}
          style={{
            backgroundImage: `url(${computerImg})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
          }}
        >
          {isPowerOn && !isMobile && (
            <div
              className="absolute bg-green-500 shadow-[0_0_10px_2px_rgba(34,197,94,0.8)] w-2 h-1 top-[69.5%] left-[54.9%] border-[0.5px] border-green-800"
              style={{
                filter: "blur(0.5px)",
                opacity: 0.8,
              }}
            />
          )}
        </div>
      )}

      {isMobile && !isPowerOn && (
        <div
          className="absolute w-full h-full top-0 left-0 z-10 opacity-30 blur-md"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
      )}

      {isMobile && isPowerOn && (
        <div className="absolute w-full h-full top-0 left-0 z-40">
          <MainScreen reset={!isPowerOn} isMobile={isMobile} />
        </div>
      )}

      {!isMobile ? (
        <button
          className={`absolute bg-transparent rounded-full z-200 ${
            isPowerOn
              ? "top-[88vh] left-[60vw] h-6 w-20"
              : "top-[69vh] left-[55vw] h-4 w-20"
          }`}
          onClick={handlePowerButton}
          aria-label="Toggle computer"
        />
      ) : (
        !isPowerOn && (
          <button
            className="fixed z-50 opacity-100 bg-transparent rounded-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-24 w-24 flex items-center justify-center"
            onClick={handlePowerButton}
            aria-label="Toggle computer"
          >
            <img
              src={powerOn}
              alt="Power button"
              className="h-full w-full object-contain shadow-[0_0_15px_5px_rgba(34,197,94,0.8)] rounded-full"
            />
          </button>
        )
      )}

      {!isMobile && (
        <div
          ref={mainScreenRef}
          style={{ display: "none" }} // initially hidden
          className="absolute w-[45%] h-[60%] top-[20%] left-[27.5%]"
        >
          <MainScreen reset={!isPowerOn} isMobile={isMobile} />
        </div>
      )}

      {(isPowerOn || initalPower) && !isMobile && (
        <img
          src={!isPowerOn ? powerOn : powerOff}
          className={`fixed top-[15%] left-[85%] h-16 w-16 rounded-full border-0 z-20 cursor-pointer ${
            !isPowerOn
              ? "shadow-[0_0_10px_2px_rgba(34,197,94,0.8)]"
              : "shadow-[0_0_10px_2px_rgba(239,68,68,0.8)]"
          }`}
          style={{
            filter: "blur(0.8px)",
            opacity: 0.8,
          }}
          onClick={handlePowerButton}
          alt="power button"
        />
      )}

      {isPowerOn && !isMobile && (
        <div className="h-[50%] w-[6%] fixed top-[30%] left-[84.5%] rounded-lg bg-black/30 backdrop-blur-sm flex flex-col justify-center gap-6 p-3 overflow-y-auto z-50">
          {socialLinks.map(({ href, Icon }) => (
            <a
              key={href}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 hover:text-white/100 hover:scale-105 transition-all flex justify-center"
            >
              <Icon className="text-4xl" />
            </a>
          ))}
        </div>
      )}

      {isPowerOn && isMobile && (
        <div className="fixed bottom-0 left-0 right-0 bg-black/80 backdrop-blur-md py-4 px-2 flex justify-around items-center z-50">
          {socialLinks.map(({ href, Icon }) => (
            <a
              key={href}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 hover:text-white/100 active:scale-95 transition-all"
            >
              <Icon className="text-2xl" />
            </a>
          ))}

          <button
            onClick={handlePowerButton}
            className="bg-red-600 rounded-full p-2 text-white active:scale-95 transition-all"
            aria-label="Power off"
          >
            <FaPowerOff className="text-2xl" />
          </button>
        </div>
      )}
    </div>
  );
}

export default App;
